import { set, unset, when } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'

export default [
  when(state`node.expandedList.${state`${props`path`}.id`}`),
  {
    true: [unset(state`node.expandedList.${state`${props`path`}.id`}`)],
    false: [set(state`node.expandedList.${state`${props`path`}.id`}`, true)]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/toggleNodeExpanded.js